<template>
  <div>
    <div class="card" style="height: 100%">
    <div class="card-body">
      <h5
        class="card-title"
        v-if="(vendorData.firstname && vendorData.lastname)"
								data-test="introduceVendorCardName"
								id="introduceVendorCardName"
      >
        {{vendorData.firstname}} {{vendorData.lastname}}</h5>
      <h6
        class="card-subtitle mb-2 text-muted"
        v-if="vendorData.request_status"
								data-test="introduceVendorCardRequestStatus"
								id="introduceVendorCardRequestStatus"
      >
        {{vendorData.request_status}}
      </h6>
      <p
        class="card-text"
        v-if="(vendorData.address_line1 && vendorData.address_line2)"
								data-test="introduceVendorCardAddress"
								id="introduceVendorCardAddress"
      >
        Address : {{vendorData.address_line1}}, {{vendorData.address_line2}}
      </p>
      <p
        class="card-text"
        v-if="vendorData.phone_number"
								data-test="introduceVendorCardPhnNo"
								id="introduceVendorCardPhnNo"
      >{{vendorData.phone_number}}</p>
      <p
        class="card-text"
        v-if="vendorData.email"
								data-test="introduceVendorCardEmail"
								id="introduceVendorCardEmail"
      >{{vendorData.email}}</p>
      <!--<a href="#" class="card-link" v-if="vendorData.phone_number">{{vendorData.phone_number}}</a>-->
      <!--<a href="#" class="card-link" v-if="vendorData.email">{{vendorData.email}}</a>-->
    </div>
  </div>
  </div>
</template>

<script>
export default {
	name: 'VendorCard',
	props: {
		vendorData: null
	}
}
</script>
